import clsx from 'clsx';
import ProductCardLite from 'components-v2/mocules/ProductCardLite';
import PaginationWithMoreAtLast from 'components-v2/organisms/pagination-with-more-at-last';
import { Controller } from 'react-hook-form';
import { useGetVoucherProducts } from '../../hooks/useGetVoucherProducts';
import { useVoucherDetailContext } from '../../PageVoucherDetail.context';
import { SectionProductsLoading } from './SectionProductsLoading';

interface Props {
  background?: string;
  limitPerPage?: number;
  className?: string;
}

export const SectionProducts = ({ className, background, limitPerPage }: Props) => {
  const { voucherInfo, isVoucherLoading } = useVoucherDetailContext();

  if (isVoucherLoading) return <SectionProductsLoading className={className} />;

  const { products, isLoading, totalPage } = useGetVoucherProducts({
    filterProduct: voucherInfo ? voucherInfo?.filterProduct || {} : undefined,
    limitPerPage: limitPerPage,
  });

  if (isLoading) return <SectionProductsLoading className={className} />;

  if (!products?.length) return <div className="w-full h-[300px] bg-white flex justify-center items-center">Không tìm thấy sản phẩm</div>;

  return (
    <>
      <div className={clsx('grid grid-cols-5 grid-flow-row gap-5', className, { 'rounded p-6': background })} style={{ background }}>
        {products?.map((product, index) => <ProductCardLite key={product.slug} product={product} id={`${product.skuCode}`} />)}
      </div>
      {!!totalPage && (
        <Controller
          name="page"
          render={({ field: { value, onChange } }) => (
            <PaginationWithMoreAtLast totalPage={totalPage} curPage={value} handleChange={(event, value) => onChange(value)} />
          )}
        />
      )}
    </>
  );
};

